import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-graphql-table';
import districtQuery from './districtsQuery.graphql';
import Modal from 'cccisd-modal';
import Tooltip from 'cccisd-tooltip';

import DistrictReport from './DistrictReport.js';
import IconReport from 'cccisd-icons/file-presentation';

const Fortress = window.cccisd.fortress;

const DistrictOverviewTable = props => {
    const userGroup = Fortress.user.acting.group?.label;
    const districtDeploymentHandle = props.deploymentHandle.slice(0, 9) + '_district';
    const renderButton = status => {
        if (!status) {
            return (
                <Tooltip title="This district has not entered data for this year.">
                    <button type="button" className="btn btn-xs btn-primary" disabled>
                        <IconReport spaceRight />
                        View Report
                    </button>
                </Tooltip>
            );
        }

        return (
            <button type="button" className="btn btn-xs btn-primary">
                <IconReport spaceRight />
                View Report
            </button>
        );
    };

    const columns = [
        { name: 'group.label', label: 'District', sort: true, filter: true },
        {
            name: 'childRoles.metricspawn.assignmentProgress.status',
            label: 'Data Entry Status',
            hideInTable: true,
            render: ({ value, row }) => (value === 'Not Started' ? 'Not Started/Imported' : value),
        },
        {
            name: 'childRoles.metricspawn.assignmentProgress.status',
            label: 'Overview Report',
            sort: true,
            className: 'text-center',
            totalPath: 'districtSummary.totalStarted',
            hideInCsv: true,
            render: ({ value, row }) => {
                if (Object.keys(row).length === 0) {
                    return value;
                }
                return (
                    <Modal
                        trigger={renderButton(row['childRoles.metricspawn.assignmentProgress.status'])}
                        size="large"
                        title={row['group.label']}
                    >
                        <DistrictReport
                            row={row}
                            reportSettings={props.reportSettings}
                            metricspawns={[row['childRoles.metricspawn.pawn.pawnId']]}
                        />
                    </Modal>
                );
            },
        },
    ];

    return (
        <Table
            rowKey="group.groupId"
            graphqlVariables={{ deploymentHandle: districtDeploymentHandle }}
            query={districtQuery}
            columns={columns}
            perPage={10}
            showTotal
            totalHeader={<div>Total districts that have started or completed data entry:</div>}
            useTaskMaster
            csvFilename={`${userGroup}_districts`}
        />
    );
};

DistrictOverviewTable.propTypes = {
    deploymentIsOpen: PropTypes.bool,
    deploymentHandle: PropTypes.string,
};

export default DistrictOverviewTable;
